import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";

export const Nav = () => {
  const navigate = useNavigate();
  const [mobileOpen, setMobileOpen] = useState(false);

  const items = [
    { label: "Created by Outpoured", to: "/create-with-us" },
    { label: "About", to: "/about" },
    { label: "Login", to: "/portal/login" },
  ];

  const go = (to) => { setMobileOpen(false); navigate(to); };

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#F4EFE6]/90 border-b border-[#D1C9BE]/60 backdrop-blur-sm">
      <nav className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-end gap-2">
          <img src="/media/logo.png" alt="Outpoured Ministries" className="h-8 md:h-9 w-auto" />
          <span className="tracking-[0.3em] uppercase text-[9px] md:text-[10px] text-[#A9724E] pb-1 md:pb-1.5">Ministries</span>
        </Link>

        <div className="hidden md:flex items-center gap-10">
          {items.map((l) => (
            <Link key={l.label} to={l.to} data-testid={`nav-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs tracking-overline uppercase text-[#5E4B3C] hover:text-[#A9724E] transition-colors duration-500">{l.label}</Link>
          ))}
        </div>

        <button aria-label={mobileOpen ? "Close menu" : "Open menu"} className="md:hidden text-[#2A2825]" onClick={() => setMobileOpen((o) => !o)} data-testid="nav-mobile-toggle">
          {mobileOpen ? <X className="w-6 h-6" strokeWidth={1.5} /> : <Menu className="w-6 h-6" strokeWidth={1.5} />}
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-[#F4EFE6] border-t border-[#D1C9BE]/60 px-6 py-6 flex flex-col gap-4">
          {items.map((l) => (
            <button key={l.label} onClick={() => go(l.to)} data-testid={`nav-mobile-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-left text-sm tracking-overline uppercase text-[#5E4B3C]">{l.label}</button>
          ))}
        </div>
      )}
    </header>
  );
};
